export const appBarHeight = 48
export const commandBarHeight = 45

export const appNavigationNavHeight = 36
export const appNavigationWidth = 180
export const appNavigationCollapseWidth = appBarHeight
